import "../../style.scss";
import Select from '@mui/material/Select';
import { useState } from 'react';


export const customSelectStyles_dark = {
    container: (baseStyles, state) => ({
        ...baseStyles,
        width: state.selectProps.width || "100%",
    }),
    menuList: (base, state) => ({
        ...base,
        maxHeight: `${state.selectProps.dropdownHeight || 200}px`, 
        overflowY: 'auto',
    }),
    control: (baseStyles, state) => ({
        ...baseStyles,
        padding: "0px",
        alignItems: "center",
        borderRadius: "8px",
        height: state.selectProps.height || "42px",
        width: state.selectProps.width || "300px",
        border: (state.isFocused || state.isDisabled) ? "none" : "0.1px solid #444",
        backgroundColor: state.isDisabled ? "var(--bgSoft)" : "#181A20", 
        boxShadow: state.isFocused ? "0 0 0 1.5px #c047fc, 0 0 0 4px #444" : "none",
        color: "#fff",
        "&:hover": {
            // borderColor: state.isFocused ? "#2B3139" : "#181A20",
        },
    }),
    option: (baseStyles, state) => ({
        ...baseStyles,
        backgroundColor: state.isSelected ? "#2B3139" : state.isFocused ? "#181A20" : "#2B3139",
        color: "#fff",
        "&:hover": {
            backgroundColor: "#181A20",
            color: "#ffffff",
            cursor: "pointer",
            transition: "top 1s ease-in-out",
        },
        borderRadius: "8px",
    }),
    singleValue: (baseStyles) => ({
        ...baseStyles,
        color: "#fff",
        fontSize: "15px",
        fontWeight: "bold",
        fontFamily: "Quicksand, sans-serif"
    }),
    menu: (baseStyles, state) => ({
        ...baseStyles,
        width: state.selectProps.width || "300px",
        backgroundColor: "#2B3139",
        borderRadius: "8px",
        color: "#fff",
        boxShadow: "0px 1px 5px rgba(0, 0, 0, 0.1)",
        border: "0.1px solid #181A20",
        padding: "0px 3px",
    }),
    input: (baseStyles) => ({
        ...baseStyles,
        color: "#fff",
    }),
    indicatorSeparator: () => ({
        display: 'none',
    }),
    loadingIndicator: (baseStyles) => ({
        ...baseStyles,
        color: "#181A20",
    }),
    dropdownIndicator: (baseStyles, state) => ({
        ...baseStyles,
        display: state.isDisabled ? 'none' : 'block',
    }),
};



export const customSelectStyles_light = {
    container: (baseStyles, state) => ({
        ...baseStyles,
        width: state.selectProps.width || "100%",

    }),
    menuList: (base, state) => ({
        ...base,
        maxHeight: `${state.selectProps.dropdownHeight || 200}px`,
        overflowY: 'auto',
    }),
    control: (baseStyles, state) => ({
        ...baseStyles,
        padding: "0px",
        display: "flex",
        alignItems: "center",
        borderRadius: "8px",
        height: state.selectProps.height || "42px",
        width: state.selectProps.width || "300px",
        border: (state.isFocused || state.isDisabled) ? "none" : "0.1px solid #ccc",
        backgroundColor: state.isDisabled ? "var(--bgSoft)" : "#ffffff",
        boxShadow: state.isFocused ? "0 0 0 1.5px #fff, 0 0 0 4px #d288f7" : "none",
        "&:hover": {
            borderColor: state.isFocused ? "#d288f7" : "#ccc",
        },

    }),
    option: (baseStyles, state) => ({
        ...baseStyles,

        backgroundColor: state.isSelected ? "#d288f7" : state.isFocused ? "#f0f0f0" : "#ffffff",
        // color: state.isSelected ? "#ffffff" : "#000",
        color: "#000",
        "&:hover": {
            backgroundColor: "rgba(210, 136, 247, 0.5)",
            // color: "#ffffff",
            color: "#000",
            cursor: "pointer",
            transition: "top 1s ease-in-out",
        },
        borderRadius: "8px",
    }),
    singleValue: (baseStyles) => ({
        ...baseStyles,
        color: "#000",
        fontSize: "15px",
        fontWeight: "bold",
        fontFamily: "Quicksand, sans-serif"
    }),
    menu: (baseStyles, state) => ({
        ...baseStyles,
        width: state.selectProps.width || "300px",
        // marginTop: "3px",
        borderRadius: "8px",
        boxShadow: "0px 1px 5px rgba(0, 0, 0, 0.1)",
        border: "0.1px solid #d288f7",
        padding: "0px 3px",
        fontSize: "14px",
        fontWeight: "300",
        fontFamily: "Quicksand, sans-serif"
    }),
    input: (baseStyles) => ({
        ...baseStyles,
        color: "#000",
    }),
    indicatorSeparator: () => ({
        display: 'none',
    }),
    loadingIndicator: (baseStyles) => ({
        ...baseStyles,
        color: "#AA00FF",
    }),
    dropdownIndicator: (baseStyles, state) => ({
        ...baseStyles,
        display: state.isDisabled ? 'none' : 'block',
    }),
};

// Style function for MUI Select
export const muiSelectStyles_dark = (isDisabled, isFocused, width = 'max-content', height = '40px') => ({
    select: {
        width,
        height,
        color: '#ffffff',
        backgroundColor: '#181A20',
        borderRadius: '5px',

        '& .MuiOutlinedInput-root': {
            backgroundColor: '#181A20',

            '& fieldset': {
                borderColor: isFocused ? '#c047fc' : '#444',
                borderWidth: '0.1px',
            },

            '&.Mui-focused fieldset': {
                borderColor: '#c047fc',
                boxShadow: '0 0 0 1.5px #c047fc, 0 0 0 4px #444',
            },

            /* DISABLED */
            '&.Mui-disabled': {
                backgroundColor: 'var(--bg)',   // bgSoft
            },

            '&.Mui-disabled fieldset': {
                border: 'none',                 // remove border
            },
        },

        '& .MuiSelect-icon': {
            color: '#fff',
            display: isDisabled ? 'none' : 'block',
        }
    },
    menu: {
        paper: {
            width: width,
            backgroundColor: '#2B3139',
            borderRadius: '5px',
            border: '0.1px solid #444',
            marginTop: '4px',
            boxShadow: '0px 1px 5px rgba(0, 0, 0, 0.1)',
            '& .MuiMenuItem-root': {
                color: '#fff',
                height: height,
                backgroundColor: '#2B3139',
                '&:hover': {
                    backgroundColor: '#181A20',
                },
                '&.Mui-selected': {
                    color: '#fff',
                    backgroundColor: '#2B3139',
                    '&:hover': {
                        backgroundColor: '#181A20',
                    }
                }
            }
        }
    }
});


export const muiSelectStyles_light = (isDisabled, isFocused, width = 'max-content', height = '40px') => ({
    select: {
        width,
        height,
        color: '#000',
        backgroundColor: '#ffffff',
        borderRadius: '5px',

        '& .MuiOutlinedInput-root': {
            backgroundColor: '#ffffff',

            '& fieldset': {
                border: isFocused ? 'none' : '0.3px solid #ccc',
            },

            '&.Mui-focused fieldset': {
                border: 'none',
                boxShadow: '0 0 0 1.5px #fff, 0 0 0 4px #00D37F',
            },

            /* DISABLED */
            '&.Mui-disabled': {
                backgroundColor: 'var(--bgSoft)',   // bgSoft
            },

            '&.Mui-disabled fieldset': {
                border: 'none',
            },
        },

        '& .MuiSelect-icon': {
            color: '#000',
            display: isDisabled ? 'none' : 'block',
        }
    },
    menu: {
        paper: {
            width: width,
            backgroundColor: '#ffffff',
            borderRadius: '5px',
            border: '0.1px solid #00D37F',
            marginTop: '4px',
            boxShadow: '0px 1px 5px rgba(0, 0, 0, 0.1)',
            '& .MuiMenuItem-root': {
                color: '#000',
                height: height,
                backgroundColor: '#ffffff',
                '&:hover': {
                    backgroundColor: 'rgba(232, 232, 249, 0.5)',
                },
                '&.Mui-selected': {
                    backgroundColor: '#e8e8f9',
                    '&:hover': {
                        backgroundColor: 'rgba(232, 232, 249, 0.5)',
                    }
                }
            }
        }
    }
});

export const ThemedSelect = ({
    darkMode,
    width = '300px',
    height = '42px',
    isDisabled,
    ...props
}) => {
    const [isFocused, setIsFocused] = useState(false);

    const styles = darkMode
        ? muiSelectStyles_dark(isDisabled, isFocused, width, height)
        : muiSelectStyles_light(isDisabled, isFocused, width, height);

    return (
        <Select
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
            sx={styles.select}
            MenuProps={{
                PaperProps: {
                    sx: {
                        ...styles.menu.paper,
                        zIndex: 9999
                    }
                }
            }}
            disabled={isDisabled}
            {...props}
        />
    );
};